export const FavoritesEmptyPostsList = () => {
  return (
    <svg
      width="149"
      height="153"
      viewBox="0 0 149 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_24407_44304)">
        <foreignObject
          x="6.01156"
          y="-4.20719"
          width="140.296"
          height="148.777"
        >
          <div
            style={{
              clipPath: 'url(#bgblur_0_24407_44304_clip_path)',
              height: '100%',
              width: '100%',
            }}
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="17.9865"
          x="48.6191"
          y="14"
          width="82.2853"
          height="94.2778"
          rx="3.31114"
          transform="rotate(15 48.6191 14)"
          fill="white"
          fillOpacity="0.7"
          stroke="url(#paint0_linear_24407_44304)"
          strokeWidth="1.92712"
        />
        <g opacity="0.43">
          <rect
            x="52.2344"
            y="20.6309"
            width="71.7673"
            height="71.7635"
            rx="1.65557"
            transform="rotate(15 52.2344 20.6309)"
            fill="#99BCFF"
          />
        </g>
        <path
          opacity="0.75"
          d="M84.073 59.5602C85.5952 58.2532 87.9547 58.8782 88.6307 60.7673L98.2086 87.5282C98.9863 89.7012 97.0034 91.8538 94.774 91.2565L49.4029 79.0994C47.1007 78.4823 46.5181 75.4861 48.4211 74.0512L62.9605 63.0902C64.2613 62.1096 66.117 62.4114 67.0401 63.7536L71.5506 70.3135L84.073 59.5602ZM72.6231 41.1592C75.657 41.9724 77.4577 45.091 76.6448 48.1249C75.8317 51.1587 72.7129 52.9593 69.679 52.1466C66.645 51.3336 64.8446 48.2149 65.6574 45.1809C66.4704 42.1468 69.589 40.3462 72.6231 41.1592Z"
          fill="white"
        />
      </g>
      <g
        filter="url(#filter2_f_24407_44304)"
        style={{ mixBlendMode: 'multiply' }}
      >
        <path
          d="M115.07 88.5132C114.869 88.6583 114.671 88.8085 114.478 88.9634C113.647 89.6301 112.839 90.4332 112.141 91.3442C111.21 90.6733 110.206 90.1375 109.218 89.7388C107.42 89.0133 105.42 88.6333 103.741 88.8804C96.8849 89.8906 92.815 96.1544 93.8545 103.211C94.268 106.017 95.6969 108.584 97.5254 110.829C99.3612 113.082 101.694 115.126 104.107 116.9C105.001 117.557 105.971 118.195 106.955 118.8L115.07 88.5132ZM105.381 115.167L104.543 114.538L104.528 114.525C104.81 114.742 105.094 114.956 105.381 115.167Z"
          fill="url(#paint1_linear_24407_44304)"
          fillOpacity="0.5"
        />
      </g>
      <path
        d="M100.601 83.5927C94.5591 85.2115 91.4781 91.2516 93.1928 97.6511C93.8596 100.139 95.4343 102.362 97.4274 104.301C99.4249 106.245 101.895 107.954 104.449 109.41C107.808 111.326 112.115 112.939 114.544 113.782C116.131 114.333 117.878 113.866 118.977 112.595C120.66 110.651 123.585 107.099 125.537 103.759C127.02 101.222 128.305 98.5061 129.063 95.8244C129.82 93.1485 130.072 90.436 129.406 87.9479C127.691 81.5484 122.003 77.858 115.961 79.4768C114.566 79.8507 113.04 80.8596 111.761 82.1551C110.821 83.1076 109.961 84.269 109.357 85.5513C108.193 84.7426 106.868 84.1668 105.577 83.8122C103.821 83.3299 101.996 83.219 100.601 83.5927Z"
        fill="url(#paint2_linear_24407_44304)"
        stroke="url(#paint3_linear_24407_44304)"
        strokeWidth="2.14999"
      />
      <path
        d="M26.4373 28.8225C25.6524 28.4549 24.7207 28.3298 23.7914 28.6823L23.6054 28.7585L23.5986 28.762C22.52 29.2565 21.9718 30.111 21.8575 31.0875C21.753 31.9816 22.0182 32.9036 22.3456 33.6693L22.3481 33.6759C22.7837 34.674 23.1317 35.4887 23.0784 36.3589L23.0787 36.3619C23.017 37.4214 22.6021 38.5557 22.0704 39.7141C21.8056 40.2912 21.5304 40.836 21.264 41.3839C21.0066 41.9133 20.7562 42.4467 20.5774 42.943L20.4743 43.259C20.2678 43.9835 20.2985 44.6104 20.404 45.0871C20.4635 45.3556 20.5455 45.5717 20.6176 45.7279C20.6514 45.801 20.6834 45.8614 20.7101 45.9087C20.7108 45.9104 20.7111 45.9123 20.7118 45.9141C20.7313 45.9624 20.76 46.0344 20.7971 46.1263C20.8711 46.3099 20.9784 46.5758 21.1111 46.9046C21.3765 47.5624 21.7442 48.4728 22.1525 49.4821C22.9688 51.5002 23.9491 53.9177 24.6031 55.5081L24.6042 55.5074C25.1984 56.9689 26.6813 57.8665 28.2542 57.6932L28.2544 57.6923C30.8136 57.4186 35.4243 56.6141 38.6498 54.2802L38.6521 54.2787C40.7794 52.7301 41.598 49.734 41.6562 46.7986C41.7153 43.8104 41.0003 40.5521 39.696 38.1295L39.6945 38.1272C38.938 36.7321 37.7807 35.9986 36.5143 35.7133C35.2884 35.4371 33.9894 35.5843 32.8593 35.8578C31.8662 36.0981 30.947 36.4525 30.2295 36.7698C30.2473 35.8327 30.1774 34.9866 30.0018 34.1801C29.7585 33.0622 29.3229 32.0661 28.7047 31.0402L28.4261 30.5938C27.9499 29.8657 27.2589 29.2074 26.4373 28.8225Z"
        fill="url(#paint4_linear_24407_44304)"
        stroke="url(#paint5_linear_24407_44304)"
        strokeWidth="1.92669"
      />
      <path
        d="M18.1576 43.6127C17.4396 43.4954 16.732 43.686 16.1544 43.931L15.9151 44.038L15.9128 44.0395C15.3232 44.3211 14.6521 44.7376 14.206 45.3465C13.7143 46.0177 13.5359 46.8769 13.9182 47.8159L13.9187 47.818C14.9152 50.2528 17.963 57.7169 18.9854 59.8172L18.9843 59.8179C19.3965 60.6737 20.1176 61.1248 20.9136 61.2437C21.6568 61.3547 22.4235 61.1761 23.0733 60.9035L23.0735 60.9026C23.6205 60.6745 24.2797 60.3164 24.7411 59.7348C25.248 59.0956 25.4529 58.2634 25.171 57.3053L25.1714 57.3034C24.7094 55.7425 23.7701 53.4923 22.8122 51.2985C21.839 49.0695 20.8452 46.8969 20.2165 45.3883L20.2158 45.3871C19.7908 44.371 19.072 43.7622 18.1576 43.6127Z"
        fill="#85AAF2"
        stroke="url(#paint6_linear_24407_44304)"
        strokeWidth="1.92669"
      />
      <defs>
        <filter
          id="filter0_dd_24407_44304"
          x="13.0064"
          y="3.5013"
          width="135.157"
          height="148.777"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4.42537" dy="10.278" />
          <feGaussianBlur stdDeviation="7.7085" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24407_44304"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4.42537" dy="5.139" />
          <feGaussianBlur stdDeviation="7.7085" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_24407_44304"
            result="effect2_dropShadow_24407_44304"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_24407_44304"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_0_24407_44304_clip_path"
          transform="translate(-6.01156 4.20719)"
        >
          <rect
            x="48.6191"
            y="14"
            width="82.2853"
            height="94.2778"
            rx="3.31114"
            transform="rotate(15 48.6191 14)"
          />
        </clipPath>
        <filter
          id="filter2_f_24407_44304"
          x="92.6964"
          y="87.5162"
          width="23.3709"
          height="32.281"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.498479"
            result="effect1_foregroundBlur_24407_44304"
          />
        </filter>
        <linearGradient
          id="paint0_linear_24407_44304"
          x1="43.3884"
          y1="2.8025"
          x2="53.41"
          y2="117.875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.280331" stopColor="#F9F9FA" stopOpacity="0.6" />
          <stop offset="1" stopColor="#F3F3F4" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_24407_44304"
          x1="95.7141"
          y1="86.543"
          x2="118.148"
          y2="129.566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#85AAF2" />
          <stop offset="1" stopColor="#85AAF2" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_24407_44304"
          x1="108.564"
          y1="80.8439"
          x2="113.306"
          y2="125.211"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#99BCFF" />
          <stop offset="1" stopColor="#85AAF2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_24407_44304"
          x1="115.387"
          y1="72.765"
          x2="74.0129"
          y2="130.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.561971" stopColor="#D2E2FF" />
          <stop offset="1" stopColor="#99BCFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_24407_44304"
          x1="30.8997"
          y1="46.4897"
          x2="44.8698"
          y2="44.4353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#85AAF2" />
          <stop offset="1" stopColor="#85AAF2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_24407_44304"
          x1="43.8916"
          y1="62.3716"
          x2="34.6786"
          y2="-8.8522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.445654" stopColor="#CCDDFF" />
          <stop offset="1" stopColor="#99BCFF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_24407_44304"
          x1="14.5984"
          y1="55.6316"
          x2="30.6541"
          y2="40.5392"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#99BCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
